import React, { useCallback } from 'react';
import {
  addBuilderNegativeStep,
  IRowMeta,
  showStepPartition,
} from '../../../../redux/slices/oldBuilder';
import { useAppDispatch } from '../../../../redux/hooks';
import { funnelPartitionTooltipOption } from '../../../KubitTooltip/globalTooltips';
import {
  SingleSelect,
  SingleSelectLabel,
  SingleSelectOption,
} from '../../../Dropdown/SingleSelect';

interface IProps {
  rowMeta: IRowMeta;
  allowExcludeEvents: boolean;
  allowPartition: boolean;
  disablePartition: boolean;
}

const BuilderStepOptions = ({
  rowMeta,
  allowExcludeEvents,
  allowPartition,
  disablePartition,
}: IProps) => {
  const dispatch = useAppDispatch();

  const handleAddExcludedEvents = useCallback(() => {
    dispatch(
      addBuilderNegativeStep({
        stepIndex: rowMeta.rowIndex,
      }),
    );
  }, [dispatch, rowMeta]);

  const handleAddPartition = useCallback(() => {
    dispatch(
      showStepPartition({
        stepIndex: rowMeta.rowIndex,
      }),
    );
  }, [dispatch, rowMeta]);

  if (!allowPartition && !allowExcludeEvents) {
    return null;
  }

  return (
    <SingleSelect
      trigger={
        <SingleSelectLabel isInteractive={true}>Step Options</SingleSelectLabel>
      }
      placement="bottom-start"
    >
      {allowPartition && (
        <SingleSelectOption
          label={'Conversion Window'}
          onClick={handleAddPartition}
          disabled={disablePartition}
          tooltipOption={funnelPartitionTooltipOption}
          tooltipPlacement="right"
        />
      )}
      {allowExcludeEvents && (
        <SingleSelectOption
          label={'Exclude Event(s)'}
          onClick={handleAddExcludedEvents}
          tooltipOption={{
            content:
              'Exclude specific event(s) from a step in the conversion funnel.',
          }}
          tooltipPlacement="right"
        />
      )}
    </SingleSelect>
  );
};

export default BuilderStepOptions;
